// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  scrollbar-width: thin !important;
  scrollbar-color: oklab(24.187% -0.03423 0.00047) transparent !important;
}
*::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important;
}
*::-webkit-scrollbar-button {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
*::-webkit-scrollbar-track {
  background: transparent !important;
}
*::-webkit-scrollbar-thumb {
  background: #506360 !important;
  border: 0 !important;
  border-radius: var(--radius-sm, 4px) !important;
}
@supports selector(::-webkit-scrollbar) {
  * {
    scrollbar-width: auto !important;
    scrollbar-color: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollbars.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,uEAAuE;AACzE;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE;IACE,gCAAgC;IAChC,gCAAgC;EAClC;AACF","sourcesContent":["* {\n  scrollbar-width: thin !important;\n  scrollbar-color: oklab(24.187% -0.03423 0.00047) transparent !important;\n}\n*::-webkit-scrollbar {\n  width: 6px !important;\n  height: 6px !important;\n}\n*::-webkit-scrollbar-button {\n  display: none !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n*::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n*::-webkit-scrollbar-thumb {\n  background: #506360 !important;\n  border: 0 !important;\n  border-radius: var(--radius-sm, 4px) !important;\n}\n@supports selector(::-webkit-scrollbar) {\n  * {\n    scrollbar-width: auto !important;\n    scrollbar-color: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
